export default function initVideo() {
  Alpine.data('video', () => ({
    startVideo() {
      const button = this.$el;
      const container = button.parentNode;
      const iframe = container?.querySelector('iframe');
      if (iframe) {
        iframe.classList.remove('hidden');
        const src = iframe.getAttribute('src');
        iframe.setAttribute('src', `${src}&autoplay=1`);
        iframe.addEventListener('load', () => {
          iframe.toggleAttribute('autoplay', true);
          button.classList.add('hidden');
          button.classList.remove('inline-flex');
          container?.querySelector('picture')?.classList.add('hidden');
        });
      }
    },
  }));
}
